export class Fisica {
  constructor() {
    this.id = 0;
    this.cpf = '';
    this.rg = '';
    this.dataNascimento = null;
    this.profissao = '';
  }

  validarCpf() {
    return true;
  }
}
